import { render, staticRenderFns } from "./TestDates.vue?vue&type=template&id=534de776&"
import script from "./TestDates.vue?vue&type=script&lang=js&"
export * from "./TestDates.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports